module.exports = __webpack_public_path__ + "assets/img/img187.19012671.png";